/* tslint:disable */
/* eslint-disable */
/**
 * All APIs
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import type { ArtifactWidgetCmaDetailsContent } from './ArtifactWidgetCmaDetailsContent';
import {
    instanceOfArtifactWidgetCmaDetailsContent,
    ArtifactWidgetCmaDetailsContentFromJSON,
    ArtifactWidgetCmaDetailsContentFromJSONTyped,
    ArtifactWidgetCmaDetailsContentToJSON,
} from './ArtifactWidgetCmaDetailsContent';
import type { ArtifactWidgetListingsSearchContent } from './ArtifactWidgetListingsSearchContent';
import {
    instanceOfArtifactWidgetListingsSearchContent,
    ArtifactWidgetListingsSearchContentFromJSON,
    ArtifactWidgetListingsSearchContentFromJSONTyped,
    ArtifactWidgetListingsSearchContentToJSON,
} from './ArtifactWidgetListingsSearchContent';

/**
 * @type UpdateArtifactDtoContent
 * a complete artifact content
 * @export
 */
export type UpdateArtifactDtoContent = ArtifactWidgetCmaDetailsContent | ArtifactWidgetListingsSearchContent;

export function UpdateArtifactDtoContentFromJSON(json: any): UpdateArtifactDtoContent {
    return UpdateArtifactDtoContentFromJSONTyped(json, false);
}

export function UpdateArtifactDtoContentFromJSONTyped(json: any, ignoreDiscriminator: boolean): UpdateArtifactDtoContent {
    if (json == null) {
        return json;
    }
    if (typeof json !== 'object') {
        return json;
    }
    if (instanceOfArtifactWidgetCmaDetailsContent(json)) {
        return ArtifactWidgetCmaDetailsContentFromJSONTyped(json, true);
    }
    if (instanceOfArtifactWidgetListingsSearchContent(json)) {
        return ArtifactWidgetListingsSearchContentFromJSONTyped(json, true);
    }
    return {} as any;
}

export function UpdateArtifactDtoContentToJSON(json: any): any {
    return UpdateArtifactDtoContentToJSONTyped(json, false);
}

export function UpdateArtifactDtoContentToJSONTyped(value?: UpdateArtifactDtoContent | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }
    if (typeof value !== 'object') {
        return value;
    }
    if (instanceOfArtifactWidgetCmaDetailsContent(value)) {
        return ArtifactWidgetCmaDetailsContentToJSON(value as ArtifactWidgetCmaDetailsContent);
    }
    if (instanceOfArtifactWidgetListingsSearchContent(value)) {
        return ArtifactWidgetListingsSearchContentToJSON(value as ArtifactWidgetListingsSearchContent);
    }
    return {};
}

